import moment from "moment";

export const getListItems = (manages, bookingData, isNew, language) => {
  return (
    manages &&
    manages.map((m) => {
      const isBookable =
        bookingData.canReserve && bookingData.canReserve.persons.includes(m.id);
      const getPrimaryText = () => {
        if (isBookable) return m.name;
        return `${m.name} (${language.alreadyBooked})`;
      };
      return {
        id: m.id,
        primaryText: getPrimaryText(),
        secondaryText: m.civicRegistrationNumber,
        photo: m.photo,
        disabled: !isBookable || isNew,
      };
    })
  );
};

export const uriWithCulture = (uri, culture) => {
  // uri with culture from state
  const url = new URL(uri);
  const params = new URLSearchParams(url.search);
  params.set("cul", culture);
  return `${url.origin}${url.pathname}?${params.toString()}`;
};

export const getDuration = (occasionDuration, activeLocale, language) => {
  if (!occasionDuration) return "";

  const humanizeUnit = (duration, unit) =>
    moment.duration(duration, unit).locale(activeLocale).humanize();

  const { minutes, hours, days, months, years } =
    moment.duration(occasionDuration)._data;

  const defaultFormatting = moment
    .duration(occasionDuration)
    .locale(activeLocale)
    .humanize();

  if (days || months || years) {
    return defaultFormatting;
  }

  const humanizedHours = humanizeUnit(hours, "hours");
  const humanizedMinutes = humanizeUnit(minutes, "minutes");

  // "1 hour" instead of "one hour" to override humanize default behaviour
  const splitHumanizedHours = humanizedHours.split(" ");
  const customHour = `${splitHumanizedHours[0].replace(/.*/, "1")} ${
    splitHumanizedHours[1]
  }`;

  if (hours === 1 && !minutes) {
    return customHour;
  }

  if (hours && minutes) {
    if (hours === 1) {
      return `${customHour} ${language.and} ${humanizedMinutes}`;
    } else {
      return `${humanizedHours} ${language.and} ${humanizedMinutes}`;
    }
  }

  return defaultFormatting;
};
